import { useEffect, useState } from 'react';
import { Button, Field, Input, Spinner, Text } from '@fluentui/react-components';
import { MessageBarType } from '@fluentui/react';
import { MessageComponent } from '../../../commons/component/MessageComponent';
import { connector, Props, useStyles } from './SectorInlineForm.Functions';
import './SectorInlineForm.Styles.css';

const SectorInlineForm = ({ branchId, onCreated, onCancel, isSaving, isSaved, failOnSaving, error, CreateSector }: Props) => {
  const styles = useStyles();
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const reset = () => {
    setName('');
    setNumber('');
    setSubmitted(false);
    setValidationErrors([]);
  };

  useEffect(() => {
    if (isSaved && submitted) {
      reset();
      onCreated?.();
    }
  }, [isSaved, submitted, onCreated]);

  const validate = () => {
    const errors: string[] = [];
    if (!name.trim()) {
      errors.push('Debe ingresar un nombre para el sector');
    }
    if (!branchId && branchId !== 0) {
      errors.push('La sede no es válida');
    }
    setValidationErrors(errors);
    return errors.length === 0;
  };

  const handleSubmit = () => {
    setSubmitted(true);
    if (!validate()) return;

    CreateSector({
      branchId,
      name: name.trim(),
      number: number.trim(),
      consultorios: []
    });
  };

  const handleCancel = () => {
    reset();
    onCancel?.();
  };

  const stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`${styles.inlineForm} sector-inline-form`}
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onKeyDown={stopPropagation}
    >
      <div className={styles.fields}>
        <Field label="Nombre" required>
          <Input value={name} onChange={(e) => setName(e.currentTarget.value)} size="small" />
        </Field>
        <Field label="Código">
          <Input value={number} onChange={(e) => setNumber(e.currentTarget.value)} size="small" />
        </Field>
      </div>
      <div className={styles.actions}>
        <Button appearance="primary" size="small" onClick={handleSubmit} disabled={isSaving}>
          {isSaving ? (
            <>
              <Spinner size="extra-tiny" /> <Text>Guardando</Text>
            </>
          ) : (
            'Guardar'
          )}
        </Button>
        <Button size="small" onClick={handleCancel} disabled={isSaving}>
          Cancelar
        </Button>
      </div>
      {validationErrors.length > 0 && (
        <MessageComponent
          message="Verifique la información suministrada"
          type={MessageBarType.error}
          itemList={validationErrors}
        />
      )}
      {failOnSaving === true && (
        <MessageComponent
          message={error?.ErrorMessage || 'Ocurrio un error inesperado'}
          type={MessageBarType.error}
          itemList={error?.Errors}
        />
      )}
    </div>
  );
};

export default connector(SectorInlineForm as any);
